/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Enter_NameInputs */

const en_onboarding_enter_name = /** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your name`)
};

const id_onboarding_enter_name = /** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan nama Anda`)
};

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const es_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const fr_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const de_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const ja_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const zh_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const ar_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const it_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const ru_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const pt_onboarding_enter_name = en_onboarding_enter_name;

/** @type {(inputs: Onboarding_Enter_NameInputs) => LocalizedString} */
const ko_onboarding_enter_name = en_onboarding_enter_name;

/**
* | output |
* | --- |
* | "Enter your name" |
*
* @param {Onboarding_Enter_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const onboarding_enter_name = /** @type {((inputs?: Onboarding_Enter_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Enter_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_enter_name(inputs)
	if (locale === "es") return es_onboarding_enter_name(inputs)
	if (locale === "fr") return fr_onboarding_enter_name(inputs)
	if (locale === "de") return de_onboarding_enter_name(inputs)
	if (locale === "ja") return ja_onboarding_enter_name(inputs)
	if (locale === "zh") return zh_onboarding_enter_name(inputs)
	if (locale === "ar") return ar_onboarding_enter_name(inputs)
	if (locale === "id") return id_onboarding_enter_name(inputs)
	if (locale === "it") return it_onboarding_enter_name(inputs)
	if (locale === "ru") return ru_onboarding_enter_name(inputs)
	if (locale === "pt") return pt_onboarding_enter_name(inputs)
	return ko_onboarding_enter_name(inputs)
});